import he from "he";
import { useTranslation } from "react-i18next";
import style from "./style.module.scss";

const DisplayBrand = ({ brand, brandProductsUrl }) => {
  // React i18next
  const { t } = useTranslation();

  return !brand ? null : (
    <div className={style.brand}>
      {brand?.logo && (
        <a href={brand.url ?? undefined} className={style.brandLogo}>
          <img src={brand.logo} alt={brand.alt} />
        </a>
      )}

      <div className={style.brandContent}>
        <a href={brand.url} className={style.brandTitle}>
          {he.decode(brand.title ?? "")}
        </a>
        <a href={brandProductsUrl} className={style.brandProductsUrl}>
          {t("See all brand products")}
        </a>
      </div>
    </div>
  );
};

export default DisplayBrand;
